module.exports = __webpack_public_path__ + "img/new-step8.60bd8570.jpg";